import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    mailing:{},
    error:''
};

export const saveMailingOption = createAsyncThunk('mailing-option/saveMailingOption', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("mailing_option",initialPost.mailing_option);
    fromData.append("Token",accessToken);
    let response = await axios.post('form/setMailingOption',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}


const MailingOptionSlice = createSlice({
    name:'mailing-option',
    initialState,
    reducers:{
        blankMailingOption:(state)=>{
            state.mailing = {};
        }
    },
    extraReducers:(builder) => {
        builder.addCase(saveMailingOption.fulfilled,(state,action)=>{
            state.mailing = action.payload
        })
    }
});

export const {blankMailingOption} = MailingOptionSlice.actions;

export default MailingOptionSlice.reducer;
